<template>
  <div class="page-container" v-loading="loading">
    <div class="title mb-12">编程出题</div>
    <el-card
      shadow="hover"
      :loading="loading"
      v-if="
        authPermissions.includes(
          'coding.api.jiker_fuwu_admin.questions.tasks.show'
        )
      "
    >
      <div slot="header">
        <span class="brand-color">出题需求</span>
      </div>
      <div class="topic-content" v-if="!$route.query.source">
        <div>
          <div class="basic-info">
            <span class="label">关联技能点：</span>
            <span>{{
              taskInfo.stacks.length ? getName(taskInfo.stacks) : "-"
            }}</span>
          </div>
          <div class="basic-info">
            <span class="label">关联考点：</span>
            <span>{{
              taskInfo.exam_tags.length ? getName(taskInfo.exam_tags) : "-"
            }}</span>
          </div>
          <div class="basic-info">
            <span class="label">编程语言限制：</span>
            <span>{{
              taskInfo.program_languages.length
                ? getName(taskInfo.program_languages)
                : "-"
            }}</span>
          </div>
        </div>
        <div>
          <div class="basic-info">
            <span class="label">任务优先级：</span>
            <span v-if="!taskInfo.priority">-</span>
            <span v-else>P{{ taskInfo.priority }}</span>
          </div>
          <div class="basic-info">
            <span class="label">任务截止时间：</span>
            <span>{{ taskInfo.end_date ? taskInfo.end_date : "-" }}</span>
          </div>
          <div class="basic-info">
            <span class="label">题目单价：</span>
            <span>{{
              taskInfo.unit_price ? "¥" + taskInfo.unit_price : "-"
            }}</span>
          </div>
        </div>
      </div>
      <div class="topic-content" v-else>
        <div>
          <div class="basic-info">
            <span class="label">关联技能点：</span>
            <span>{{
              questionForm.stacks.length ? "-" : getName(questionForm.stacks)
            }}</span>
          </div>
          <div class="basic-info">
            <span class="label">关联考点：</span>
            <span>{{
              questionForm.examPointArr.length
                ? String(questionForm.examPointArr)
                : "-"
            }}</span>
          </div>
          <div class="basic-info">
            <span class="label">编程语言限制：</span>
            <span>{{
              questionForm.programmingLanguage.length
                ? getName(questionForm.programmingLanguage)
                : "-"
            }}</span>
          </div>
        </div>
      </div>
      <div
        class="basic-info verity"
        v-if="questionForm.verity_logs && questionForm.status == 3"
      >
        <span class="label">驳回原因：</span>
        <markdown-it :md="questionForm.verity_logs"></markdown-it>
      </div>
    </el-card>
    <el-form
      class="question-info"
      label-width="150px"
      :model="questionForm"
      :rules="questionRules"
      :validate-on-rule-change="false"
      ref="questionForm"
      @submit.native.prevent
      v-if="questionStep == 1"
    >
      <el-card class="mt-20" shadow="hover">
        <div slot="header" class="title-flex" style="">
          <span class="brand-color">题目设置</span>
          <span
            v-if="
              authPermissions.includes(
                'coding.api.jiker_fuwu_admin.questions.update'
              )
            "
          >
            <el-button
              v-if="[1, 3].includes(questionForm.status)"
              size="mini"
              @click="$emit('editing', !editing)"
              >{{ editing ? "取消修改" : "修改" }}</el-button
            >
          </span>
        </div>
        <el-form-item label="题目来源：" prop="source">
          <el-radio-group v-model="questionForm.source" :disabled="!editing">
            <el-radio
              v-for="(item, index) in sourceList"
              :key="index"
              :label="index + 1"
              >{{ item }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="难度等级：" prop="level">
          <el-radio-group
            v-model="questionForm.level"
            :disabled="!editing"
            size="small"
          >
            <el-radio-button :label="1">R1-简单</el-radio-button>
            <el-radio-button :label="2">R2-一般</el-radio-button>
            <el-radio-button :label="3">R3-中等</el-radio-button>
            <el-radio-button :label="4">R4-困难</el-radio-button>
            <el-radio-button :label="5">R5-非常困难</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="考点：" prop="examPointArr">
          <div v-if="editing">
            <ExamPoint
              :disabled="!editing"
              @updateArr="handleUpdatePoint"
              :examPointArr="questionForm.examPointArr"
              :autoCompleteVisible.sync="autoCompleteVisible"
            ></ExamPoint>
            <el-button
              size="small"
              v-if="!autoCompleteVisible"
              @click="showExamPoint"
              >添加考点</el-button
            >
          </div>
          <div v-else>
            <span class="flex exam-box">
              <el-tag
                v-for="(item, index) in questionForm.examPointArr"
                :key="index"
                size="small"
                style="margin-right:4px"
                >{{ item }}</el-tag
              >
            </span>
          </div>
        </el-form-item>
        <el-form-item prop="score" label="题目分值">
          <template v-slot:label>
            题目分值
            <el-popover placement="top-start" trigger="hover">
              <p class="popover-title">
                题目的默认分值，根据实际使用场景有可能会用到此分值
              </p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
            ：
          </template>
          <el-input
            :autofocus="true"
            size="small"
            class="w-135"
            v-model="questionForm.score"
            :disabled="!editing"
          >
            <template slot="suffix"><span class="mr-12">分</span></template>
          </el-input>
        </el-form-item>
        <el-form-item label="题目作答时间" prop="answer_time">
          <template v-slot:label>
            题目作答时间
            <el-popover placement="top-start" trigger="hover">
              <p class="popover-title">
                建议作答时间，请根据题目难度及题目描述长度酌情设置
              </p>
              <ul class="popover-list">
                <li class="popover-item">R1 - 10±5min</li>
                <li class="popover-item">R2 - 15±5min</li>
                <li class="popover-item">R3 - 20±5min</li>
                <li class="popover-item">R4 - 25±5min</li>
                <li class="popover-item">R5 - 30±5min</li>
              </ul>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
            ：
          </template>
          <el-input-number
            class="mr-4 w-135"
            v-model="questionForm.answer_time"
            :controls="false"
            style="text-align: left"
            size="small"
            :disabled="!editing"
          ></el-input-number>
          <el-select
            size="small"
            v-model="questionForm.time_type"
            :disabled="!editing"
            class="w-60"
          >
            <el-option label="分" :value="1"></el-option>
            <el-option label="秒" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="autoJudge">
          <template v-slot:label>
            自动判题
            <el-popover placement="top-start" trigger="hover">
              <ul class="popover-list">
                <li class="popover-item">
                  启用：编程分析引擎将会自动分析用户多维度编程能力，适用于自动出分析结果的场景
                </li>
                <li class="popover-item">
                  禁用：编程分析引擎将不会自动分析用户编程能力，适用于不需要结果、单纯查看编程代码的场景
                </li>
              </ul>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
            ：
          </template>
          <el-radio
            :disabled="!editing"
            v-model="questionForm.autoJudge"
            :label="1"
            >启用</el-radio
          >
          <el-radio
            v-model="questionForm.autoJudge"
            :disabled="!editing"
            :label="0"
            >禁用</el-radio
          >
        </el-form-item>

        <el-form-item label="行业分类：" prop="common_industries">
          <el-cascader
            v-model="questionForm.common_industries"
            size="small"
            :options="industryList"
            :props="optionProps"
            class="w-400"
            placeholder="请选择行业分类"
            :disabled="!editing"
          ></el-cascader>
        </el-form-item>
        <slot v-if="!editing" name="program-code"> </slot>
      </el-card>

      <el-card class="mt-20" v-if="editing" shadow="hover">
        <div slot="header">
          <span class="brand-color">题目内容</span>
        </div>
        <div class="flex">
          <el-form-item prop="timeMax">
            <template v-slot:label>
              时间限制
              <el-popover placement="top-start" width="500" trigger="hover">
                <p class="popover-title">
                  指编译时间，一般1-10秒之间，有助于编程分析引擎对用户编程能力多维度的评估
                </p>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </template>
            <el-input
              :disabled="!editing"
              class="w-170"
              v-model="questionForm.timeMax"
              size="small"
            >
              <template slot="suffix"><span class="mr-12">秒</span></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="spaceMax">
            <template v-slot:label>
              空间限制
              <el-popover placement="top-start" width="500" trigger="hover">
                <p class="popover-title">
                  指对代码运行的内存空间的要求，一般不超过512M，有助于编程分析引擎对用户编程能力多维度的评估
                </p>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </template>
            <el-input
              :disabled="!editing"
              class="w-135"
              v-model="questionForm.spaceMax"
              size="small"
            >
              <template slot="suffix"><span class="mr-12">M</span></template>
            </el-input>
          </el-form-item>
        </div>
        <slot name="program-info">
          <el-tabs tab-position="left" v-model="activeName">
            <el-tab-pane
              v-for="(item, index) in questionForm.languages"
              :key="index"
              :label="item.label"
              :name="item.lang"
            >
              <el-form-item
                :prop="`languages[${index}].title`"
                label="题目标题："
              >
                <el-input
                  maxlength="100"
                  class="w-90pc"
                  size="small"
                  show-word-limit
                  placeholder="不超过100字"
                  v-model="item.title"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="题目描述："
                :prop="`languages[${index}].stem`"
              >
                <Markdown
                  class="w-90pc"
                  defaultOpen="edit"
                  :autofocus="false"
                  :value.sync="item.stem"
                  space="_for_skill_sub_project"
                  folder="admin"
                ></Markdown>
              </el-form-item>
              <el-form-item
                label="解析："
                :prop="`languages[${index}].analysis`"
              >
                <Markdown
                  class="w-90pc"
                  defaultOpen="edit"
                  style="z-index:1 !import"
                  :autofocus="false"
                  :value.sync="item.analysis"
                  space="_for_skill_sub_project"
                  folder="admin"
                ></Markdown>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
        </slot>
        <el-form-item label="初始代码：" prop="program">
          <template v-slot:label>
            初始代码：
            <el-popover placement="top-start" width="500" trigger="hover">
              <p class="popover-title">
                此模块为给学生默认展示的初始代码，如没有可不填。
              </p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
          </template>
          <el-select
            v-model="currentLanguage"
            class="w-300"
            size="small"
            value-key="id"
            placeholder="请选择编程语言"
          >
            <el-option
              v-for="(programming, index) in questionForm.programmingLanguage"
              :key="index"
              :label="programming.name"
              :value="programming"
            >
            </el-option>
          </el-select>
          <div v-if="currentLanguage" class="code-area">
            <OnlineCodeOutput
              :language.sync="getLanguage"
              :inputCode.sync="questionForm.program[currentLanguage.name]"
              :key.sync="currentLanguage.name"
              :env="env"
              :isVertical="true"
              title="初始代码"
              :showDownload="false"
              :showOutInput="true"
              :answer.sync="questionForm.output"
              @failed="failed"
              @success="success"
            />
          </div>
        </el-form-item>
        <el-form-item label="测试用例：" prop="caseList">
          <template v-slot:label>
            测试用例
            <el-popover placement="top-start" trigger="hover">
              <ul class="popover-list">
                <li class="popover-item">请考虑多种极限值，并至少添加2组</li>
                <li class="popover-item">
                  测试用例有助于规避用户通过print输出内容绕过代码分析；
                </li>
                <li class="popover-item">
                  多个测试用例意味着标准答案不唯一，有助于多维检测用户编程能力；
                </li>
                <li class="popover-item">支持单变量测试用例和多变量测试用例</li>
              </ul>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
            ：
          </template>
          <div class="case-button-box">
            <el-button
              plain
              type="primary"
              size="small"
              :disabled="!editing"
              @click="showTestCaseDialog"
              >添加测试用例</el-button
            >
            <div class="case-button-text">请考虑多种极限值，并至少添加5组</div>
          </div>
          <TestCase
            v-if="currentLanguage"
            @addCase="handleAddCase"
            :caseItem.sync="caseItem"
            :caseList="questionForm.caseList"
            :testCaseVisible.sync="testCaseVisible"
            :currentLanguage="currentLanguage"
          ></TestCase>
          <el-table
            v-show="questionForm.caseList.length"
            :data="questionForm.caseList"
            style="width: 100%"
          >
            <el-table-column type="index" label="编号" width="90">
            </el-table-column>
            <el-table-column prop="input" label="输入" width="280">
              <template v-slot="scope">
                <span class="input-cell">{{
                  scope.row.type == 1
                    ? scope.row.input
                    : getInput(scope.row.input)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="output" width="210" label="输出">
              <template v-slot="scope">
                <!-- <el-table :data="scope.row.output" size="mini" style="width: 100%" border>
              <div v-for="(item, index) in scope.row.columnName" :key="index">
                <el-table-column :prop="item" :label="item" width="180">
                </el-table-column>
              </div>
            </el-table> -->
                <div v-if="typeof scope.row.output === 'string'">
                  {{ scope.row.output }}
                </div>
                <div class="table-content" v-else>
                  <table border="1">
                    <thead>
                      <tr>
                        <th
                          v-for="(oItem, oIndex) in scope.row.columnName"
                          :key="oIndex"
                          class="table-head"
                        >
                          {{ oItem }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(outItem, outIndex) in scope.row.outputTarget"
                        :key="outIndex"
                      >
                        <td
                          class="table-td"
                          v-for="name in scope.row.columnName"
                          :key="name"
                        >
                          {{ outItem[name] }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- {{
                  scope.row.output
                    ? typeof scope.row.output === "string"
                      ? scope.row.output
                      : JSON.stringify(scope.row.outputTarget)
                    : ""
                }} -->
              </template>
            </el-table-column>
            <el-table-column width="100" label="答题页显示"
              ><template v-slot="scope">
                {{ scope.row.display ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              width="100"
              v-if="editing"
            >
              <template v-slot="scope">
                <el-link
                  :underline="false"
                  @click="handleEditCase(scope.row, scope.$index)"
                  >编辑</el-link
                >
                <el-divider direction="vertical"></el-divider>
                <el-link
                  :underline="false"
                  @click="handleDeleteCase(scope.$index)"
                  >删除</el-link
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <div v-if="editing" style="width: 100%; text-align: center">
          <el-button
            plain
            type="primary"
            size="small"
            v-loading="nextLoading"
            @click="handleSubmit"
            >下一步：验证题目</el-button
          >
        </div>
      </el-card>
    </el-form>
    <el-card v-else class="mt-20">
      <div slot="header">
        <span class="brand-color"
          >题目验证
          <el-popover placement="top-start" trigger="hover">
            <p class="popover-title">
              请在此处输入正确的运行代码作为参考答案。
            </p>
            <i class="el-icon-question" slot="reference"></i> </el-popover
        ></span>
      </div>
      <QuestionContent
        :questionForm="questionForm"
        ref="question-content"
        @questionStatus="handleStatus"
        :channel="'create'"
      ></QuestionContent>
      <div class="button-box" v-if="editing">
        <el-button plain @click="questionStep = 1" size="small"
          >返回上一步</el-button
        >
        <el-button
          v-if="type == 'create'"
          plain
          type="primary"
          size="small"
          :disabled="saveStatus"
          :loading="saveLoading"
          @click="handleSave"
          >验证通过，提交题目</el-button
        >
        <el-button
          v-else
          plain
          type="primary"
          size="small"
          :disabled="saveStatus"
          @click="handleUpdate"
          >修改题目</el-button
        >
        <div class="button-box-title">
          ! 请验证通过全部测试用例，方可提交题目
        </div>
        <el-link
          class="button-box-link"
          @click="handleCode"
          :underline="false"
          type="primary"
          >一键验证</el-link
        >
      </div>
    </el-card>
  </div>
</template>

<script>
// import ProgramQuestionTask from "./widgets/ProgramQuestionTask.vue";
import { mapState } from "vuex";
import TestCase from "./widgets/TestCase.vue";
import Markdown from "@/components/Markdown";
import codeService from "@/global/service/code";
import ExamPoint from "./widgets/ExamPointd.vue";
import kcellService from "@/global/service/kcell";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import QuestionContent from "./widgets/QuestionContent.vue";
import OnlineCodeOutput from "@/components/OnlineCodeOutput.vue";
const env = process.env.NODE_ENV == "development" ? "vip" : "prod";
import common from "./widgets/common";
export default {
  mixins: [common],
  props: {
    questionDetail: {
      type: Object
    },
    editing: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "create"
    },
    value: {},
    detailTaskId: {
      type: Number
    }
  },
  components: {
    TestCase,
    Markdown,
    OnlineCodeOutput,
    QuestionContent,
    MarkdownIt,
    ExamPoint
    // ProgramQuestionTask,
  },
  data() {
    return {
      env,
      timeList: [15, 20, 25, 30, 35],
      taskInfo: {
        stacks: [],
        exam_tags: [],
        program_languages: []
      },
      loading: false,
      inputContent: null,
      questionStep: 1,
      autoCompleteVisible: false,
      nextLoading: false,
      testCaseVisible: false,
      oneKeyStatus: true,
      btnLoading: false,
      questionData: {},
      questionCode: [],
      saveStatus: true,
      questionForm: {
        question_type: 1, // 题目类型：1 编程题；2 绘图题；3 简答题
        examPointArr: [],
        score: "",
        level: 1, // 难易等级：1 简单；2 普通；3 困难
        source: 6,
        timeMax: null,
        spaceMax: null,
        output: null,
        time_type: 1,
        common_industries: [],
        programmingLanguage: [],
        languages: [
          {
            lang: "zh",
            label: "中文",
            title: "",
            stem: "",
            analysis: ""
          },
          {
            lang: "en",
            label: "英文",
            title: "",
            stem: "",
            analysis: ""
          },
          {
            lang: "fr",
            label: "法文",
            title: "",
            stem: "",
            analysis: ""
          }
        ],
        program: {},
        example: {},
        autoJudge: 1,
        caseList: []
      },
      caseItem: null,
      caseIndex: null,
      columnName: [],
      questionRules: {
        question_type: { required: true },
        examPointArr: [
          { required: true, message: "请添加考点", trigger: "change" }
        ],
        score: [
          { required: true, message: "请输入题目得分", trigger: "change" },
          {
            validator: this.validateScore,
            trigger: ["change", "blur"]
          }
        ],
        level: { required: true },
        source: { required: true },
        common_industries: [{ required: true, trigger: "blur" }],
        timeMax: [
          {
            required: true,
            message: "请输入时间限制",
            trigger: ["change", "blur"]
          },
          {
            validator: this.validateInt,
            trigger: ["change", "blur"]
          }
        ],
        spaceMax: [
          {
            required: true,
            message: "请输入空间限制",
            trigger: ["change", "blur"]
          },
          {
            validator: this.validateInt,
            trigger: ["change", "blur"]
          }
        ],
        programmingLanguage: [
          {
            required: true,
            message: "请选择编程语言",
            trigger: ["change"]
          }
        ],
        answer_time: [
          {
            required: true,
            message: "请输入作答时间",
            trigger: "blur"
          }
        ],
        languages: [
          {
            title: {
              required: true,
              message: "请输入题目标题",
              trigger: ["change", "blur"]
            },
            stem: {
              required: true,
              message: "请输入题目描述",
              trigger: ["change", "blur"]
            },
            analysis: {
              required: true,
              message: "请输入题目解析",
              trigger: ["change", "blur"]
            }
          }
        ],
        autoJudge: {
          required: true
        },
        caseList: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length) {
                callback();
              } else {
                callback(new Error("请添加测试用例"));
              }
            },
            message: "请添加测试用例",
            trigger: ["change", "blur"]
          }
        ]
      },
      activeName: "zh",
      currentLanguage: "",
      saveLoading: false,
      industryList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      }
    };
  },
  watch: {
    "questionForm.level"(val) {
      if (val) {
        this.questionForm.answer_time = this.timeList[val - 1];
      }
    },
    inputContent(val) {
      this.$emit("update:inputCode", val);
    },
    currentLanguage(language) {
      this.questionForm.program[language.name] = this.questionForm.program[
        language.name
      ]
        ? this.questionForm.program[language.name]
        : "";
    },
    "questionForm.languages": {
      handler(val) {
        if (val[0].stem || val[0].analysis) {
          this.$refs.questionForm.validateField(`languages[${0}].stem`);
          this.$refs.questionForm.validateField(`languages[${0}].analysis`);
        }
      },
      deep: true
    },
    questionDetail(val) {
      if (val) {
        this.questionForm = this.questionDetail;
        this.currentLanguage = this.questionForm.programmingLanguage[0];
      }
    }
  },
  computed: {
    ...mapState(["authPermissions"]),
    getName() {
      return arr => {
        if (arr) {
          return arr.map(item => item.name).join("、");
        }
      };
    }
  },
  created() {
    this.getConst();
    this.taskId =
      this.type == "detail" ? this.detailTaskId : this.$route.params.id;
    if (this.questionDetail) {
      this.questionForm = this.questionDetail;
      this.currentLanguage = this.questionForm.programmingLanguage[0];
    }
    if (!this.taskId) {
      return;
    }
    this.getData();
  },
  methods: {
    getConst() {
      kcellService.kcellIndustry().then(res => {
        this.industryList = res;
      });
    },
    getData() {
      const mode = this.authPermissions.includes(
        "coding.api.jiker_fuwu_admin.questions.tasks.show"
      );
      if (!mode) {
        return;
      }
      this.loading = true;
      codeService.getTaskInfo(this.taskId).then(res => {
        this.questionForm.programmingLanguage = res.program_languages;
        this.taskInfo = res;
        this.loading = false;
        this.currentLanguage = this.questionForm.programmingLanguage[0];
      });
    },
    validateInt(rules, value, callback) {
      if (
        Number.isInteger(Number(value)) &&
        Math.floor(Number(value)) === Number(value)
      ) {
        if (Math.abs(value) == value) {
          if (!(value > 0 && value <= 10000000)) {
            callback(new Error("请输入范围在1到10000000"));
            return;
          }
          callback();
        } else {
          callback(new Error("请输入正数"));
        }
      } else {
        callback(new Error("请输入整数"));
      }
    },
    validateScore(rules, value, callback) {
      if (
        Number.isInteger(Number(value)) &&
        Math.floor(Number(value)) === Number(value)
      ) {
        if (Math.min(value, 10) == value) {
          if (Math.abs(value) == value) {
            callback();
          } else {
            callback(new Error("请输入正数"));
          }
        } else {
          callback(new Error("题目分值小于10"));
        }
      } else {
        callback(new Error("请输入整数"));
      }
    },
    success(res) {
      this.$emit("update:outputCode", res.data);
    },
    failed() {
      this.$message.error("运行错误，请检查输入是否正确");
    },
    handleSubmit() {
      this.$refs.questionForm.validate(valid => {
        if (valid) {
          this.questionData = this.handleFormData();
          const displayNum = this.questionForm.caseList.filter(
            item => item.display
          ).length;
          const noDisplayNum = this.questionForm.caseList.filter(
            item => !item.display
          ).length;
          if (this.questionForm.caseList.length < 5) {
            this.$message.error("请考虑多种极限值，并至少添加5组");
            return;
          }
          if (
            this.questionForm.caseList.length == displayNum ||
            this.questionForm.caseList.length == noDisplayNum
          ) {
            this.$message.error("测试用例不能全隐藏或全显示");
            return;
          }
          if (
            !(this.questionData.contents.zh.description.length < 1500) ||
            !(this.questionData.contents.zh.analysis.length < 1500)
          ) {
            return this.$message.error("题目描述或解析最好不超过1500字");
          }
          this.handleNext();
        }
      });
    },
    handleNext() {
      const caseList = [];
      this.questionData.cases.forEach(data => {
        caseList.push({
          input:
            data.type == 1
              ? data.input
              : data.input.map(item => {
                  return item.value;
                }),
          output: data.output
        });
      });
      const params = {
        language: this.getLanguage,
        cases: caseList,
        code: window.btoa(encodeURIComponent(this.questionData.codes[0].code)),
        type: 1
      };
      this.nextLoading = true;
      codeService
        .questionCase(params)
        .then(res => {
          if (res.pass_count) {
            this.$message.warning("初始代码可跑通测试用例，请检查初始代码");
          } else {
            this.questionStep = 2;
            this.saveStatus = true;
            document.documentElement.scrollTop = 0;
          }
        })
        .finally(() => {
          this.nextLoading = false;
        });
    },
    handleSave() {
      this.questionData = this.handleFormData();
      this.questionData.cases = this.questionData.cases?.map(item => {
        const output =
          typeof item.output == "string"
            ? item.output
            : JSON.stringify(item.output);
        return Object.assign({}, item, { output: output });
      });
      this.saveLoading = true;
      this.questionData.industry_id = this.$route.query.industryId
        ? this.$route.query.industryId
        : 0;
      codeService
        .programCreate(this.questionData)
        .then(() => {
          this.$message.success("题目创建成功");
          this.$router.push({ name: "programTaskList" });
        })
        .finally(() => {
          this.btnLoading = false;
          this.saveLoading = false;
        });
    },
    handleFormData() {
      const contents = {};
      const answer_time =
        this.questionForm.time_type === 1
          ? this.questionForm.answer_time * 60
          : this.questionForm.answer_time;
      const {
        score,
        level,
        source,
        caseList: cases,
        examPointArr: tags,
        autoJudge: is_auto_judge,
        timeMax: limit_time,
        spaceMax: limit_memory,
        question_type: type,
        common_industries: common_industries,
        id
      } = this.questionForm;
      const languagesValid = this.questionForm.languages.every(lan => {
        if (lan.title && lan.analysis && lan.stem) {
          contents[lan.lang] = {
            title: lan.title, // 标题
            analysis: lan.analysis, // 分析
            description: lan.stem // 描述
          };
          if (lan.id) {
            contents[lan.lang].id = lan.id;
          }
        } else if (lan.title || lan.analysis || lan.stem) {
          this.$message.error(
            `请输入${lan.label}题目${
              lan.title ? (lan.analysis ? "描述" : "解析") : "标题"
            }`
          );
          return false;
        }
        return true;
      });
      if (!languagesValid) {
        return false;
      }
      const codes = this.questionForm.programmingLanguage.map(key => {
        return {
          id: this.languagesList.indexOf(key.name) + 1,
          name: key.name,
          code: this.questionForm.program[key.name] || "",
          sample_code: this.questionCode[key.name]
        };
      });
      // const programmingLanguage = this.questionForm.programmingLanguage
      const params = {
        type,
        score,
        level,
        source,
        limit_time,
        limit_memory,
        is_auto_judge,
        tags,
        cases,
        contents,
        codes,
        answer_time,
        common_industries,
        id
      };
      if (this.$route.query.source) {
        params.fork_question_id = this.questionForm.id;
      } else {
        params.question_task_id = this.taskId;
      }
      return params;
    },
    showExamPoint() {
      this.autoCompleteVisible = true;
    },
    handleUpdatePoint({ val, type }) {
      if (type === "add") {
        this.questionForm.examPointArr.push(val);
      } else {
        this.questionForm.examPointArr.splice(
          this.questionForm.examPointArr.indexOf(val),
          1
        );
      }
    },
    showTestCaseDialog() {
      this.testCaseVisible = true;
      this.$refs.questionForm.clearValidate("caseList");
    },
    handleAddCase(e) {
      if (this.caseItem) {
        this.questionForm.caseList.splice(this.caseIndex, 1, e);
      } else {
        if (this.currentLanguage.name == "Oracle") {
          e.columnName = e.output ? Object.keys(e.outputTarget[0]) : "";
          this.questionForm.caseList.push(e);
          return;
        }
        e.columnName =
          e.output && e.output.length ? Object.keys(e.output[0]) : "";
        this.questionForm.caseList.push(e);
      }
    },
    handleEditCase(item, index) {
      this.caseItem = item;
      this.caseIndex = index;
      this.showTestCaseDialog();
    },
    handleDeleteCase(index) {
      this.questionForm.caseList.splice(index, 1);
    },
    handleStatus(val) {
      this.questionCode = val;
      this.saveStatus = this.questionCode ? false : true;
    },
    handleUpdate() {
      const params = this.handleFormData();
      params.cases = params.cases.map(item => {
        const output =
          typeof item.output == "string"
            ? item.output
            : JSON.stringify(item.output);
        return Object.assign({}, item, { output: output });
      });
      const id = params.id;
      codeService.updateProgram(id, params).then(() => {
        this.$message.success("题目信息修改成功");
        this.questionStep = 1;
        this.$emit("editing", false);
      });
    },
    handleCode() {
      this.$refs["question-content"].handleCodeSubmit();
    }
  }
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
.exam-box {
  margin-top: 8px;
}
/deep/.title {
  margin-bottom: 0px;
  font-size: 16px;
}
.add-btn {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1501;
}
.table-content {
  overflow-y: auto;
  padding: 4px;
  table,
  td {
    border: 1px solid #000000;
    border-collapse: collapse;
  }
}
.table-head {
  padding: 2px 4px;
  text-align: center;
  font-weight: 500;
}
.table-td {
  padding: 2px 4px;
  text-align: center;
}
.page-container {
  position: relative;
  min-height: 100vh;
  .flex {
    display: flex;
  }
  .input-cell {
    word-break: break-all;
  }
}
.code-area {
  position: relative;
  height: 440px;
  text-align: left;

  /deep/.run-button {
    display: none !important;
  }
}
.popover-title {
  // margin-bottom: 10px;
  line-height: 22px;
}
.popover-list {
  padding-left: 35px;
  .popover-item {
    font-size: 14px;
    line-height: 22px;
  }
}
/deep/.text-container,
/deep/.table-container {
  display: none;
}
/deep/.vue-codemirror {
  width: 100% !important;
}
.topic-content {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-right: 60px;
}
.basic-info {
  margin-bottom: 12px;
  font-size: 14px;
  padding: 0 20px;
  &.verity {
    display: flex;
    align-items: flex-start;
  }
  .label {
    display: inline-block;
    width: 100px;
    text-align: right;
  }
}
.title-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button-box {
  display: flex;
  justify-content: center;
  align-items: center;
  .button-box-title {
    margin: 0 10px;
    font-size: 12px;
  }
  .button-box-link {
    font-size: 12px;
  }
}
/deep/.el-input-number.is-without-controls .el-input__inner {
  text-align: left !important;
}
.case-button-box {
  position: relative;
  width: 100px;
  cursor: pointer;
  .case-button-text {
    position: absolute;
    font-size: 12px;
    width: 200px;
    top: 0%;
    left: 113%;
    color: rgba(0, 0, 0, 0.45);
    display: none;
  }
  &:hover {
    .case-button-text {
      display: block;
    }
  }
}
.button-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .button-box-title {
    font-size: 12px;
    margin: 0 10px;
    color: rgb(0, 0, 0, 0.65);
  }
  .button-box-link {
    font-size: 12px;
  }
}
.code-area {
  /deep/.result {
    display: none;
  }
}
</style>
